const projectConfig = {
    // tenantCode: '100066855236', // UAT
    // apiId: 'cVc4OGCV', // UAT
    // apiKey: 'ee5c30e5b43c46975bddc00f1105035ce47d5229', // UAT
    // boapi: "https://uat-login-comotv.sdmc.tv", // UAT
    // collectionApi: "https://uat-collection-comotv.sdmc.tv", // UAT
    // adapi: '/ad/v1', // UAT
    // adBaseURL: 'https://uat-admsapi-comotv.sdmc.tv/v1', // 三星广告BaseURL UAT

    tenantCode: '100090902883', //  prod
    apiId: 'wuAM4GpP', //  prod
    apiKey: '0a9a406b09714ddc34af30c5e66841e920e8a06b', //  prod
    boapi: "https://login-tv.comofootball.com",
    collectionApi: "https://collection-tv.comofootball.com", // Prod
    adBaseURL: 'https://admsapi-tv.comofootball.com/v1', // 三星广告BaseURL Prod
    adapi: '/v1', // Prod
    
    defaultParentPinCode: "0000", // 默认父母控制PIN码
    paymentDownTime: 900, // 付款倒计时，单位秒
    version: "1.0.0",
    webiste: "https://tv.comofootball.com ",
    contactEmail: "comotv-support@comofootball.com",
    defaultLanguage: "it-IT",
    theme: "dart", // 主题 light、dart
    lang: [
    {
        label: 'Italiano',
        value: 'it-IT',
        key: 'it',
        shortValue: 'Italiano'
    },
    {
        label: 'English',
        value: 'en_US',
        key: 'en',
        shortValue: 'English'
    },
    // {
    //     label: 'Bahasa Indonesia',
    //     value: 'id-ID',
    //     key: 'id',
    //     shortValue: 'Bahasa indonesia'
    // },
    // {
    //     label: '简体中文',
    //     value: 'zh_CN',
    //     key: 'zhCn',
    //     shortValue: '简体中文'
    // },
    // {
    //     label: 'Melayu',
    //     value: 'ms-MY',
    //     key: 'ms-MY',
    //     shortValue: 'Melayu'
    // },
    ]
}

export default projectConfig;